import { makeStyles } from '~/UIKit/Style';
import { IBorder } from './TemplateBox.types';
import { PRIMARY_BLUE, WHITE, BORDER_COLOR } from '../../../Constants/Colors.constants';

interface TemplateBoxStyleProps {
  border?: IBorder;
}
export const useTemplateBoxStyles = ({ border = 'default' }: TemplateBoxStyleProps) =>
  makeStyles(() => ({
    container: {
      display: 'flex',
      borderRadius: '1px',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '30px 27.5px',
      height: '239px',
      border: `${border === 'dashed' ? 'dashed' : 'solid'} 1px ${
        border === 'default' ? BORDER_COLOR : PRIMARY_BLUE
      }`,
    },
    svg: {
      height: '24px',
    },
    title: {
      fontSize: '14px',
      fontWeight: 'bold',
    },
    description: {
      fontSize: '12px',
      textAlign: 'center',
      width: '70%',
      lineHeight: '19px',
    },
    link: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      textDecoration: 'none',
    },
    button: {
      width: '100%',
      height: '35px',
      backgroundColor: PRIMARY_BLUE,
      color: WHITE,
      fontSize: '14px',
      fontWeight: 'bold',
      '&:hover': {
        backgroundColor: PRIMARY_BLUE,
      },
    },
    highlight: {
      border: 'solid 1px #0084F8',
      backgroundColor: 'rgba(0,132,248,0.07)',
    },
  }));
